import { Injectable } from '@angular/core';

import { Angulartics2 } from 'angulartics2';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { isObject, isString } from 'util';

import * as AppStateActions from '../actions/app-state';
import * as LoginActions from '../actions/login';
import * as ConfigActions from '../actions/config';
import * as UraniaAdminActions from '../actions/urania-admin';

import { State } from '../reducers';
import { WindowRef } from '../../services/window-ref';
import { CONFIG_SCOPE_NEO, CONFIG_SCOPE_URANIA, CONFIG_SCOPE_XENA, CONFIG_SCOPE_XENA_GLOBAL } from '../reducers/config';
import { TabCountService } from '../../services/broadcast-channel/tab-count.service';
import { SAVE_CONFIG_SUCCESS, SaveConfigSuccess } from '../actions/config';
import { RELOAD_NEO_FRAME, ReloadNeoFrame } from '../actions/app-state';
import { NeoFrameService } from '../../../neo-frame/neo-frame.service';
import { WebsocketService } from '../../services/websocket/websocket.service';
import { CrsBridgeService } from '../../services/crs-bridge/crs-bridge.service';
import { ResetTopsFlopsAction } from '../../../xena/core/shared/components/tops-flops/state-management/actions/tops-flops';


@Injectable()
export class AppEffects {
	@Effect({dispatch: false}) onLogin$ = this.actions$
		.ofType<LoginActions.LoginSuccessful>(LoginActions.LOGIN_SUCCESSFUL)
		.map(action => action.payload)
		.do(claims => this.window.nativeWindow['_mfq'].push(['setVariable', 'USERID', claims.sub, 'session', false]))
		.do(claims => this._angulartics2.setUsername.next(`${claims.sub}`))
		.do(claims => {
			this._crsBridge.connect(claims && claims.bridgeConfig && claims.bridgeConfig.httpsPort || 15001);
			this._websocket.subscribeToChannels([`user:${claims.sub}`]);
		})
		.do(() => this._tc.init());

	@Effect({dispatch: false}) triggerLoadConfig$ = this.actions$
		.ofType<AppStateActions.SelectAgency>(AppStateActions.SELECT_AGENCY)
		.map(action => action.payload)
		.do(payload => {
			this._store.dispatch(new ResetTopsFlopsAction());
			this._store.dispatch(new ConfigActions.LoadConfig(CONFIG_SCOPE_XENA));
			this._store.dispatch(new ConfigActions.LoadConfig(CONFIG_SCOPE_XENA_GLOBAL));
			this._store.dispatch(new ConfigActions.LoadConfig(CONFIG_SCOPE_NEO));
			this._websocket.subscribeToChannels([`agent:${payload.agentId}`]);
		});

	@Effect({dispatch: false}) triggerLoadUraniaConfig$ = this.actions$
		.ofType<UraniaAdminActions.SelectUraniaCfg>(UraniaAdminActions.SELECT_URANIA_CFG)
		.do(action => {
			if (isObject(action) && isObject(action.payload) && isString(action.payload.cfg)) {
				this._store.dispatch(new ConfigActions.LoadConfig(CONFIG_SCOPE_URANIA));
			}
		});

	@Effect({dispatch: false}) triggerNeoFrameReload$ = this.actions$
		.ofType<SaveConfigSuccess>(SAVE_CONFIG_SUCCESS)
		.do(action => {
			if (isObject(action) && action.scope === 'neo') {
				this._store.dispatch(new ReloadNeoFrame());
			}
		});

	@Effect({dispatch: false}) reloadNeoFrame$ = this.actions$
		.ofType<ReloadNeoFrame>(RELOAD_NEO_FRAME)
		.do(() => this._neoFrameService.reloadNeoFrame$.next(true));

	constructor(
		private actions$: Actions,
		private window: WindowRef,
		private _angulartics2: Angulartics2,
		private _tc: TabCountService,
		private _store: Store<State>,
		private _neoFrameService: NeoFrameService,
		private _websocket: WebsocketService,
		private _crsBridge: CrsBridgeService,
	) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/state-management/effects/app.ts